import {Component, Input, OnInit} from '@angular/core';
import {GoalService} from "../../services/goal.service";
import {AuthService} from "../../../auth/services/auth.service";
import {Goal} from "../../models/goal";
import {TandemUser} from "../../../auth/models/tandem-user";

@Component({
  selector: 'tandem-goals',
  templateUrl: './goals.component.html',
  styleUrls: ['./goals.component.scss']
})
export class GoalsComponent implements OnInit {

  @Input() reviewingUser: TandemUser | null = null;

  shortTermGoals: Goal[] = [];
  midTermGoals: Goal[] = [];
  longTermGoals: Goal[] = [];

  userId: string = '';
  currentShortTermSortDirection: 'ascending' | 'descending' = "ascending";
  currentMidTermSortDirection: 'ascending' | 'descending' = "ascending";
  currentLongTermSortDirection: 'ascending' | 'descending' = "ascending";

  constructor(private auth: AuthService,
              private goalService: GoalService) {
  }

  ngOnInit(): void {
    this.auth.$user.subscribe(user => {
      if (this.reviewingUser) {
        this.goalService.listByUserId(this.reviewingUser.uid).subscribe(goals => {
          this.shortTermGoals = [];
          this.midTermGoals = [];
          this.longTermGoals = [];
          goals.forEach(goal => {
            if (goal.type === 'Short-Term') {
              this.shortTermGoals.push(goal);
            } else if (goal.type === 'Mid-Term') {
              this.midTermGoals.push(goal);
            } else if (goal.type === 'Long-Term') {
              this.longTermGoals.push(goal);
            }
          });
          this.shortTermGoals = this.shortTermGoals.sort((a, b) => {
            if(a.targetDate.seconds > b.targetDate.seconds) {
              return 1
            }
            if(a.targetDate.seconds < b.targetDate.seconds) {
              return -1
            }
            if(a.targetDate.seconds == b.targetDate.seconds) {
              return 0
            }
            return 0
          });
          this.midTermGoals = this.midTermGoals.sort((a, b) => {
            if(a.targetDate.seconds > b.targetDate.seconds) {
              return 1
            }
            if(a.targetDate.seconds < b.targetDate.seconds) {
              return -1
            }
            if(a.targetDate.seconds == b.targetDate.seconds) {
              return 0
            }
            return 0
          });
          this.longTermGoals = this.longTermGoals.sort((a, b) => {
            if(a.targetDate.seconds > b.targetDate.seconds) {
              return 1
            }
            if(a.targetDate.seconds < b.targetDate.seconds) {
              return -1
            }
            if(a.targetDate.seconds == b.targetDate.seconds) {
              return 0
            }
            return 0
          });
          this.shortTermGoals.sort((a: Goal, b: Goal) => {
            if (a.completed && !b.completed) {
              return 1;
            }
            if (!a.completed && b.completed) {
              return -1;
            }
            return 0;
          })
          this.midTermGoals.sort((a: Goal, b: Goal) => {
            if (a.completed && !b.completed) {
              return 1;
            }
            if (!a.completed && b.completed) {
              return -1;
            }
            return 0;
          })
          this.longTermGoals.sort((a: Goal, b: Goal) => {
            if (a.completed && !b.completed) {
              return 1;
            }
            if (!a.completed && b.completed) {
              return -1;
            }
            return 0;
          })
        });
      } else {
        if (user) {
          this.userId = user.uid;
          this.goalService.listByUserId(user.uid).subscribe(goals => {
            this.shortTermGoals = [];
            this.midTermGoals = [];
            this.longTermGoals = [];
            goals.forEach(goal => {
              if (goal.type === 'Short-Term') {
                this.shortTermGoals.push(goal);
              } else if (goal.type === 'Mid-Term') {
                this.midTermGoals.push(goal);
              } else if (goal.type === 'Long-Term') {
                this.longTermGoals.push(goal);
              }
            });
            this.shortTermGoals = this.shortTermGoals.sort((a, b) => {
              if(a.targetDate.seconds > b.targetDate.seconds) {
                return 1
              }
              if(a.targetDate.seconds < b.targetDate.seconds) {
                return -1
              }
              if(a.targetDate.seconds == b.targetDate.seconds) {
                return 0
              }
              return 0
            });
            this.midTermGoals = this.midTermGoals.sort((a, b) => {
              if(a.targetDate.seconds > b.targetDate.seconds) {
                return 1
              }
              if(a.targetDate.seconds < b.targetDate.seconds) {
                return -1
              }
              if(a.targetDate.seconds == b.targetDate.seconds) {
                return 0
              }
              return 0
            });
            this.longTermGoals = this.longTermGoals.sort((a, b) => {
              if(a.targetDate.seconds > b.targetDate.seconds) {
                return 1
              }
              if(a.targetDate.seconds < b.targetDate.seconds) {
                return -1
              }
              if(a.targetDate.seconds == b.targetDate.seconds) {
                return 0
              }
              return 0
            });
            this.shortTermGoals.sort((a: Goal, b: Goal) => {
              if (a.completed && !b.completed) {
                return 1;
              }
              if (!a.completed && b.completed) {
                return -1;
              }
              return 0;
            })
            this.midTermGoals.sort((a: Goal, b: Goal) => {
              if (a.completed && !b.completed) {
                return 1;
              }
              if (!a.completed && b.completed) {
                return -1;
              }
              return 0;
            })
            this.longTermGoals.sort((a: Goal, b: Goal) => {
              if (a.completed && !b.completed) {
                return 1;
              }
              if (!a.completed && b.completed) {
                return -1;
              }
              return 0;
            })
            this.shortTermGoals = this.shortTermGoals.sort((a: Goal, b: Goal) => {
              if(a.completed && b.completed) {
                return -1
              }
              return 0
            })
          });
        }
      }
    });
  }

  onGoalCreated(goal: Goal) {
    this.goalService.add(goal).then(res => {
      this.shortTermGoals = [...this.shortTermGoals];
      this.midTermGoals = [...this.midTermGoals];
      this.longTermGoals = [...this.longTermGoals];
    })
  }
  onSortGoals(event : 'Short-Term' | 'Mid-Term' | 'Long-Term') {
    if(event == 'Short-Term') {
      this.currentShortTermSortDirection = this.currentShortTermSortDirection === 'ascending' ? 'descending' : 'ascending';
      this.shortTermGoals = this.shortTermGoals.sort((a, b) => {
        if(a.targetDate.seconds > b.targetDate.seconds) {
          return this.currentShortTermSortDirection == 'ascending' ? -1 : 1;
        }
        if(a.targetDate.seconds < b.targetDate.seconds) {
          return this.currentShortTermSortDirection == 'ascending' ? 1 : -1;
        }
        if(a.targetDate.seconds == b.targetDate.seconds) {
          return 0
        }
        return 0
      });
      this.shortTermGoals = this.shortTermGoals.sort((a: Goal, b: Goal) => {
        if (a.completed && !b.completed) {
          return 1;
        }
        if (!a.completed && b.completed) {
          return -1;
        }
        return 0;
      })
    }
    else if(event == 'Mid-Term') {
      this.currentMidTermSortDirection = this.currentMidTermSortDirection === 'ascending' ? 'descending' : 'ascending';
      this.midTermGoals = this.midTermGoals.sort((a, b) => {
        if(a.targetDate.seconds > b.targetDate.seconds) {
          return this.currentMidTermSortDirection == 'ascending' ? -1 : 1;
        }
        if(a.targetDate.seconds < b.targetDate.seconds) {
          return this.currentMidTermSortDirection == 'ascending' ? 1 : -1;
        }
        if(a.targetDate.seconds == b.targetDate.seconds) {
          return 0
        }
        return 0
      });
      this.midTermGoals = this.midTermGoals.sort((a: Goal, b: Goal) => {
        if (a.completed && !b.completed) {
          return 1;
        }
        if (!a.completed && b.completed) {
          return -1;
        }
        return 0;
      })
    }
    else if(event == 'Long-Term') {
      this.currentLongTermSortDirection = this.currentLongTermSortDirection === 'ascending' ? 'descending' : 'ascending';
      this.longTermGoals = this.longTermGoals.sort((a, b) => {
        if(a.targetDate.seconds > b.targetDate.seconds) {
          return this.currentLongTermSortDirection == 'ascending' ? -1 : 1;
        }
        if(a.targetDate.seconds < b.targetDate.seconds) {
          return this.currentLongTermSortDirection == 'ascending' ? 1 : -1;
        }
        if(a.targetDate.seconds == b.targetDate.seconds) {
          return 0
        }
        return 0
      });
      this.longTermGoals = this.longTermGoals.sort((a: Goal, b: Goal) => {
        if (a.completed && !b.completed) {
          return 1;
        }
        if (!a.completed && b.completed) {
          return -1;
        }
        return 0;
      })
    }
  }

  onGoalUpdated(goal: Goal) {
    this.goalService.update(goal).then(res => {
      this.shortTermGoals = [...this.shortTermGoals];
      this.midTermGoals = [...this.midTermGoals];
      this.longTermGoals = [...this.longTermGoals];
    })
  }

  onGoalDeleted(goal: Goal) {
    this.goalService.delete(goal.id!).then(res => {
      this.shortTermGoals = [...this.shortTermGoals];
      this.midTermGoals = [...this.midTermGoals];
      this.longTermGoals = [...this.longTermGoals];
    })
  }

}
